import Typography from '@/common/components/base/typography/Typography';
import LoadingPage from '@/common/pages/LoadingPage';
import StarImage from '@/modules/Statistics/assets/icons/Star.svg?react';
import { Box, Flex } from 'styled-system/jsx';
import { GetAdjustersListQueryResponseType } from '../../queries/getAdjustersList/getAdjustersListQuery.type';
import useInfinityScroll from '@/common/hooks/useInfinityScroll';

export default function RankingList({
  data,
  fetchNextPage,
  activeTab,
  isLoading,
  isFetchingNextPage,
}: {
  data?: GetAdjustersListQueryResponseType;
  fetchNextPage: () => void;
  activeTab: 'country' | 'province';
  isLoading?: boolean;
  isFetchingNextPage?: boolean;
}) {
  const { observerRefCallback } = useInfinityScroll(fetchNextPage);

  if (isLoading) {
    return <LoadingPage height="30vh" />;
  }

  return (
    <Box>
      {data?.map((item) => (
        <Flex
          justifyContent="space-between"
          alignItems="center"
          borderBottom="1px solid"
          borderColor="gray-3"
          py="16px"
          key={item.id}
          ref={observerRefCallback}
        >
          <Flex alignItems="center" gap="20px">
            <Typography color="black">
              {activeTab === 'country'
                ? item?.national_rank
                : item?.province_rank}
            </Typography>
            <Typography textStyle="b1" color="black">
              {item?.adjuster?.full_name}
            </Typography>
          </Flex>

          <Flex alignItems="center" gap="6px">
            <Typography>{item?.weighted_score}</Typography>
            <StarImage />
          </Flex>
        </Flex>
      ))}

      {isFetchingNextPage && <LoadingPage height="70px" />}
    </Box>
  );
}
